import React, { Component } from 'react';
import DeviceTable from '../dashboard/DeviceTable';

class Devices extends Component {
  render() {
    return (
      <div className="content">
        <DeviceTable />
      </div>
    );
  }
}

export default Devices;
